import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from "@angular/router";
import { NgxUiLoaderService, SPINNER } from 'ngx-ui-loader';
import { AuthenticationService } from "../services/authentication.service";
import Swal from 'sweetalert2';
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { GooglePlaceDirective } from "node_modules/ngx-google-places-autocomplete/ngx-google-places-autocomplete.directive";
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { GoogleGeocodingService } from 'src/app/services/google-geo-coding.service';

declare const google: any;
declare module "googlemaps";

@Component({
  selector: 'app-select-criteria',
  templateUrl: './select-criteria.component.html',
  styleUrls: ['./select-criteria.component.css']
})
export class SelectCriteriaComponent implements OnInit {
  public isArea = false;
  public form: FormGroup;
  public plan: any;
  public cName: any;
  public cType: any;
  addressModel: NgbModalRef;
  updateAddModel: NgbModalRef;
  activeSaveModal: NgbModalRef;
  public addresses = [];
  public addressLocation: any;
  public locationModel: any;
  public subscriptions: any;
  public price: any;
  public location: any;
  public changeLocation: any;
  public radiusId: any;
  public selectedRadiusSub: any;
  public subscriptionPlanType: any;

  // Added missing property declarations
  public addOnPlans: any[] = [];
  public selectedAddOnPlan: any = null;
  public isSubmitting = false;

  address1: any;
  boundsLimit = true;
  show = false;
  loading = false;
  defaultBounds: any;
  addStatus = false;

  @ViewChild("placesRef") placesRef: GooglePlaceDirective;
  @ViewChild('saveLocationModal') saveLocationModalRef: any;
  spinnerType = SPINNER.circle;
  zone: any;

  constructor(
    private modalService: NgbModal,
    public fb: FormBuilder,
    public authenticationService: AuthenticationService,
    private ngxService: NgxUiLoaderService,
    public router: Router,
    private googleGeocodingService: GoogleGeocodingService
  ) { }

  public durationOptions = [
    { key: '1_WEEK', label: '1 Week', days: 7 },
    { key: '2_WEEKS', label: '2 Weeks', days: 14 },
    { key: '1_MONTH', label: '1 Month', days: 30 },
    { key: '3_MONTHS', label: '3 Months', days: 90 },
    { key: '6_MONTHS', label: '6 Months', days: 180 },
    { key: '1_YEAR', label: '1 Year', days: 365 }
  ];

  ngOnInit(): void {
    this.plan = JSON.parse(localStorage.getItem('planDetail')) || {};
    this.address1 = JSON.parse(localStorage.getItem('address1'));
    this.price = this.plan.price || 0;

    this.form = this.fb.group({
      city: ['', [Validators.required]],
      state: ['', [Validators.required]],
      googleAddress: ['', [Validators.required]],
      streetAddress: ['', [Validators.required]],
      country: ['', [Validators.required]],
      postalCode: ['', [Validators.required]]
    });

    this.getAddOnPlans();
    this.getSubscription();
  }

  getAddOnPlans() {
    this.ngxService.start();
    // Uses getPlan('AddOn') which calls /comman/getTimes?basePrice=AddOn in AuthenticationService
    this.authenticationService.getPlan('false').subscribe(
      (res: any) => {
        this.ngxService.stop();
        console.log('DEBUG >> raw API response:', JSON.stringify(res, null, 2));
        this.addOnPlans = res?.data || res || [];
        console.log('DEBUG >> addOnPlans array:', this.addOnPlans);
        if (Array.isArray(this.addOnPlans) && this.addOnPlans.length > 0) {
          this.selectAddOnPlan(this.addOnPlans[0]);
        }
      },
      error => {
        this.ngxService.stop();
        console.error('Failed to load AddOn plans', error);
      }
    );
  }


  selectStaticDuration(uiKey: string, captionMatch: string, hardcodedPrice: number) {
    const matchedPlan = this.addOnPlans.find(p =>
      p.price === hardcodedPrice ||
      (p.caption && p.caption.toLowerCase().includes(captionMatch.toLowerCase()))
    );

    if (!matchedPlan) {
      Swal.fire('Error', `This plan is not configured on the server. Please contact support.`);
      return;
    }
    matchedPlan.value = uiKey;
    this.selectAddOnPlan(matchedPlan);
  }

  selectAddOnPlan(plan: any) {
    this.selectedAddOnPlan = plan;
    this.plan = plan;
    this.price = plan.price;
    this.subscriptionPlanType = plan._id;

    if (this.selectedRadiusSub) {
      this.price = this.selectedRadiusSub.multiplier * this.plan.price;
    }
  }

  selectDuration(durationKey: string, days: number) {
    const matchedPlan = this.addOnPlans.find(p => p.days === days);

    if (!matchedPlan) {
      Swal.fire('Error', `This plan (${days} days) is not configured on the server. Please contact support.`);
      return;
    }

    matchedPlan.__uiKey = durationKey;
    this.selectAddOnPlan(matchedPlan);
  }

  getPriceForDays(days: number): number | string {
    const matchedPlan = this.addOnPlans.find(p => p.days === days);
    return matchedPlan ? matchedPlan.price : '--';
  }

  selectType(val) {
    this.show = false;
    this.loading = true;
    if (val) {
      setTimeout(() => {
        this.show = true;
        this.loading = false;
      }, 1500);
    }

    if (val == 1) {
      this.isArea = true;
    } else if (val == 2) {
      this.isArea = false;
    }
  }

  selectCriteria(sub) {
    this.selectedRadiusSub = sub;
    this.radiusId = sub._id;
    this.price = sub.multiplier * (this.plan ? this.plan.price : 0);
  }

  checkout() {
    if (!this.radiusId) {
      Swal.fire("Error", "Radius or Area is required");
      return;
    } else if (this.addresses.length == 0) {
      Swal.fire("Error", "Location address is required");
      return;
    } else if (this.price === null || this.price === undefined || this.price === '') {
      Swal.fire("Error", "Price is required");
      return;
    }

    this.isSubmitting = true;
    this.ngxService.start();

    let addInfo: any = {
      radiusId: this.radiusId,
      address: this.addresses,
      amount: this.price,
      planId: this.subscriptionPlanType,
      coverageType: this.isArea ? 'radius' : 'area',
      areaType: this.selectedRadiusSub?.area
    };
    console.log("this.isArea-0-0-0-0-0-00-", this.isArea)
    console.log("this.isArea ? this.selectedRadiusSub?.area : ''", this.isArea ? this.selectedRadiusSub?.area : '')
    console.log("this.selectedRadiusSub?.area", this.selectedRadiusSub?.area)
 
    this.authenticationService.validateSubscription(addInfo).subscribe(
      (validateData: any) => {
        this.authenticationService.cardList().subscribe(
          (cardData: any) => {
            let cards = cardData?.data?.cards || cardData?.cards;
            if (!cards || cards.length === 0) {
              this.ngxService.stop();
              this.isSubmitting = false;
              Swal.fire("No Card Found", "Please add a payment card before creating an ad.");
              return;
            }
            let defaultCardId = cards[0].id;
            console.log("cards---------------------------------------------", cards)
            let payInfo = {
              stripeToken: defaultCardId,
              refrenceId: validateData['data'].refrenceId,
              isRecurring: false
            };

            this.authenticationService.requestPayment(payInfo).subscribe(
              (payData: any) => {
                this.ngxService.stop();
                this.isSubmitting = false;

                // Store payload details before navigating
                localStorage.setItem('criteria', JSON.stringify({
                  radiusId: this.radiusId,
                  address: this.addresses,
                  amount: this.price,
                  planId: this.subscriptionPlanType,
                  refrenceId: validateData['data'].refrenceId,
                  discount: this.plan?.discount || 0
                }));

                this.addAdvertisement();
              },
              error => {
                this.ngxService.stop();
                this.isSubmitting = false;
                Swal.fire("Payment Failed", error?.error?.message || "Payment processing failed.");
              }
            );
          },
          error => {
            this.ngxService.stop();
            this.isSubmitting = false;
            Swal.fire("Error", "Could not fetch saved cards.");
          }
        );
      },
      error => {
        this.ngxService.stop();
        this.isSubmitting = false;
        if (error?.error?.message === 'location_exist' || error?.error?.msg === 'location_exist' || error?.error?.message?.includes('Location name already exist')) {
          Swal.fire({
            icon: 'warning',
            title: 'Location Name Already In Use',
            text: 'This location name is already linked to one of your ads. Please choose a different name or edit the existing ad instead.',
            confirmButtonText: 'Choose Different Location'
          }).then(() => {
            this.openSaveLocationModal();
          });
        } else {
          Swal.fire("Error", error?.error?.message || "Validation failed");
        }
      }
    );
  }


  openSaveLocationModal() {
    this.activeSaveModal = this.modalService.open(this.saveLocationModalRef, {
      backdrop: true,
      keyboard: true,
      centered: true
    });
  }

  addAdvertisement() {
    let adObj = {};
    adObj['title'] = this.address1.title;
    adObj['imagePath'] = this.address1.imagePath;
    adObj['description'] = this.address1.description;
    adObj['address'] = this.addresses;
    adObj['startDate'] = this.address1.startDate;
    adObj['endDate'] = this.address1.endDate;
    adObj['radiusId'] = this.radiusId;
    adObj['subscriptionId'] = JSON.parse(localStorage.getItem('criteria'))?.refrenceId;

    this.authenticationService.addAdvertisement(adObj).subscribe(
      (response: any) => {
        this.ngxService.stop();
        Swal.fire("", "Advertisement is created successfully.", 'success');
        this.router.navigate(['/advertisements']);
      },
      error => {
        this.ngxService.stop();
        if (error) {
          Swal.fire("Error", error.error.message, "error");
        }
      }
    );
  }

  validateSubscription(coupon) {
    this.ngxService.start();
    this.authenticationService.validateSubscription(coupon).subscribe(
      data => {
        Swal.fire("", "Coupon is applied successfully", "success");
        this.ngxService.stop();
      },
      error => {
        Swal.fire("error", error.error.message);
        this.ngxService.stop();
      }
    );
  }

  getSubscription() {
    this.authenticationService.getSubscription().subscribe(
      data => {
        this.subscriptions = data['data'];
      },
      error => {
        if (error?.error?.message == "Unauthorized") {
          this.authenticationService.logout();
        }
      }
    );
  }

  public AddressChange(address: any) {
    this.form.controls['streetAddress'].setValue(address.formatted_address);
    this.form.controls['googleAddress'].setValue(address.name);
    var latitude = address.geometry.location.lat();
    var longitude = address.geometry.location.lng();
    this.addressLocation = { "type": "Point", "coordinates": [latitude, longitude] };
    let address_components = address.address_components;
    for (let i = 0; i < address_components.length; i++) {
      if (address_components[i].types[0] == 'administrative_area_level_2') {
        this.form.controls['city'].setValue(address_components[i].long_name);
      } else if (address_components[i].types[0] == 'administrative_area_level_1') {
        this.form.controls['state'].setValue(address_components[i].long_name);
      } else if (address_components[i].types[0] == 'country') {
        this.form.controls['country'].setValue(address_components[i].long_name);
      } else if (address_components[i].types[0] == 'postal_code') {
        this.form.controls['postalCode'].setValue(address_components[i].long_name);
      }
    }
  }

  selectOrigin(content) {
    this.addressModel = this.modalService.open(content, {
      backdrop: 'static',
      keyboard: false
    });
  }

  changeLocationName(value) {
    this.addStatus = true;
    this.location = value.googleAddress;
    this.form.controls['googleAddress'].setValue(value.googleAddress);
    if (this.activeSaveModal) {
      this.activeSaveModal.close();
    }
  }

  cancelModal() {
    if (this.activeSaveModal) {
      this.activeSaveModal.dismiss();
    }
  }

  addAddresses(value) {
    this.addresses = [];
    this.location = value.googleAddress;
    if (!value.postalCode) {
      Swal.fire("Error", "Postal code is required");
      return;
    } else if (!value.streetAddress) {
      Swal.fire("Error", "City name is required");
      return;
    } else if (!value.state) {
      Swal.fire("Error", "State name is required");
      return;
    } else if (!value.country) {
      Swal.fire("Error", "Country name is required");
      return;
    }
    let address = {};
    address['city'] = value.city;
    address['state'] = value.state;
    address['country'] = value.country;
    address['googleAddress'] = value.googleAddress;
    address['streetAddress'] = value.streetAddress;
    address['postalCode'] = value.postalCode;
    address['location'] = this.addressLocation;

    this.addresses.push(address);
    this.form.reset(this.form.value);
    this.addressModel.close();

    this.activeSaveModal = this.modalService.open(this.saveLocationModalRef, {
      backdrop: true,
      keyboard: true,
      centered: true
    });
  }

  limitCheckbox(e) {
    this.boundsLimit = e.target.checked;
  }

  redirectTo() {
    this.router.navigateByUrl('/dashboard');
  }
}